import { asyncModalAdapter } from 'App/helpers/angularPortingHelpers';

export const openCreateActivityAction = asyncModalAdapter({
	featureFlag: 'CREATE_ACTIVITY_ACTION_REACT',
	upModalName: 'CreateActivityAction',
	openModalName: 'CreateActivityAction'
});
